import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { usePresentationContext } from '../../../legacy-context/presentationContext';
import type { VideoState } from '../utils';
import { Overlay } from './Overlay';

export const VideoOverlay = ({ children }: React.PropsWithChildren) => {
  const { useSlideState } = usePresentationContext();
  const [{ videoState }, setSlideState] = useSlideState<VideoState>();

  const onDismiss = () => {
    setSlideState({ videoState: 'closed' });
  };
  const show = videoState && videoState !== 'closed';

  return (
    <Overlay show={show} onDismiss={onDismiss}>
      <Box
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
        extend={() => ({
          background: 'rgba(100,100,100,0.7)',
        })}
        onClick={onDismiss}
      >
        {show ? children : null}
      </Box>
    </Overlay>
  );
};
